module.exports = __webpack_public_path__ + "img/pålestikk_tredd_6.0aa1bcf9.jpg";